class KlaviyoForm extends HTMLElement {

  /**
   * The constructor method is a special method of a class for creating
   * and initializing an object instance of that class.
   */
  constructor() {
    super();
    const { api, revision, detail } = this.dataset;
    this.form = this.querySelector('form');
    if (!api || !revision || !this.form) return;
    this.api = api;
    this.revision = revision;
    this.submitButton = this.querySelector('[type="submit"]');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.url = {
      email: 'https://a.klaviyo.com/client/back-in-stock-subscriptions',
    };
    this.errorPlace = this.querySelector('[data-error-message]');
    if (!this.closest('[popover]')) return;

    document.querySelectorAll('[popovertarget="back-in-stock"][popovertargetaction="show"]').forEach((btn) => btn.addEventListener('click', ({currentTarget}) => sessionStorage.setItem('back-in-stock', currentTarget.dataset.detail)));

    this.closest('[popover]').addEventListener('beforetoggle', (event) => {
      const settings = JSON.parse(sessionStorage.getItem('back-in-stock'));
      const titleElement = this.querySelector('[data-product-title]');
      const imgElement = this.querySelector('img');
      if (event.newState === 'closed' && this.form) {
        this.classList.remove('form-error','form-success');
        this.form.reset();
      }
      if (event.newState !== 'open' || !settings) return;
      const { title, image, alt, id } = settings;
      if (titleElement && title) titleElement.innerText = title;
      if (imgElement && image) imgElement.src = image;
      if (imgElement && alt) imgElement.alt = alt;
      if (id) this.dataset.variantId = id;
    });
  }

  /**
   * The getProductVarianId method is a special method of a class for
   * get product variant ID.
   * @name getProductVarianId
   * @kind function
   * @returns {string} The variant ID
   */
  getProductVarianId() {
    const { variantId } = this.dataset;
    if (variantId) return `${variantId}`;
  }

  /**
   * The onSubmitHandler method is a special method of a class for
   * send form to Klaviyo.
   * @param {Event} event The represents an event which takes place
   * in the DOM.
   * @name onSubmitHandler
   * @kind function
   */
  onSubmitHandler(event) {
    event.preventDefault();

    if (!this.form) return;
    const formData = new FormData(this.form);
    const email = formData.get('email');

    this.classList.remove('form-error');
    this.submitButton.setAttribute('aria-disabled', 'true');
    this.submitButton.classList.add('loading');
    if (this.querySelector('.loading__spinner'))
      this.querySelector('.loading__spinner').classList.remove('hidden');

    const requestParameters = new URLSearchParams({
      company_id: this.api
    });

    this.options = [...formData.entries()].reduce((p, [key, value]) => ({
      ...p,
      [`${key}`]: {
        method: 'POST',
        headers: {
          revision: this.revision,
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: { id: 'subscription', email: 'back-in-stock-subscription' }[key],
            attributes: {
              ...({
                id: { custom_source: 'backinstock_pop_up' },
                email: { channels: ['EMAIL'] }
              }[key]),
              profile: { data: { type: 'profile', attributes: { email } } }
            },
            relationships: {
              ...({
                id: { list: { data: { type: 'list', id: value } } },
                email: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.getProductVarianId()}` } } }
              }[key])
            }
          }
        })
      }
    }), {});

    (async () => {
      const { country, locale } = window.Shopify;
      await fetch(`https://a.klaviyo.com/client/events?${requestParameters}`, {
        method: 'POST',
        headers: {
          revision: this.revision,
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: { locale, country, languages: `${locale}_${country}` },
              metric: { data: { type: 'metric', attributes: { name: 'backinstock_pop_up' } } },
              profile: { data: { type: 'profile', attributes: { email } } }
            }
          }
        })
      });
      await Object.entries(this.options).reduce(async (p, [key, option]) => {
        await p;
        const response = await fetch(`${this.url[key]}?${requestParameters}`, option);
        if (response.ok || !this.errorPlace) return;
        const { errors } = await response.json();
        const error = (errors || [{title: null}]).map(({ title }) => title).join('\n') || 'HTTP error';
        this.errorPlace.insertAdjacentText('beforeend', error);
        this.classList.add('form-error');
      }, Promise.resolve());

      this.submitButton.setAttribute('aria-disabled', 'false');
      this.submitButton.classList.remove('loading');
      if (this.querySelector('.loading__spinner'))
        this.querySelector('.loading__spinner').classList.add('hidden');

      if (!this.form || [...this.classList].indexOf('form-error') !== -1) return;

      this.classList.add('form-success');
      this.form.reset();
    })();
  }
}

customElements.define('klaviyo-form', KlaviyoForm);